import React, { useEffect, useState } from "react";
import {
  CustomButton2,
  CustomIcon,
  CustomInput,
  CustomModal,
} from "../../../../components";
import Context from "../../../../context";

import "./index.scss";
// import SelectArea from "./SelectArea";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Row } from "react-bootstrap";
import Column from "../../../../components/CustomView/Column";

const Update = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, updateArea, selectedArea, loading } =
    React.useContext(Context.AreaScreen);

  const [areaName, setAreaName] = useState<string>(
    selectedArea?.title as string
  );

  useEffect(() => {
    setAreaName(selectedArea?.title as string);
  }, [selectedArea]);

  // const [selectedArea, setSelectedArea] = useState<
  //   { lat: number; lng: number }[] | undefined
  // >(undefined);
  // const [areaName, setAreaName] = useState<string>("");
  // const [errors, setErrors] = useState<{ area: string }>({ area: "" });

  const onSubmit = async () => {
    // if (selectedArea === undefined) {
    //   setErrors({ area: "محدوده مورد نظر را انتخاب کنید" });
    // }
    const result = await updateArea!({
      _id: selectedArea?._id,
      name: areaName,
      // , coords
    });
  };

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <section id="create-update-area-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "UPDATE"}
        minWidth={"20rem"}
        // minHeight={"60vh"}
      >
        <form onSubmit={onSubmit}>
          <Row>
            <Column medium={12}>
              <CustomInput
                name="name"
                label={"نام منطقه"}
                id="name"
                value={areaName}
                onValueChange={(e) => setAreaName(e.target.value)}
              />
            </Column>
          </Row>

          {/* <Row>
            <Column className="dropdown">
              <SelectArea
                setAreaState={setSelectedArea}
                areaState={selectedArea as { lat: number; lng: number }[]}
                defaultAreaLatLng={[32, 53]}
              />
              <div className="error">{errors?.area !== "" && errors?.area}</div>
            </Column>
          </Row> */}
          <Row>
            <Column medium={4}>{""}</Column>
            <Column medium={4}>
              <CustomButton2
                type="primary"
                onClick={onSubmit}
                title={"ویرایش منطقه"}
                isLoading={loading}
              />
            </Column>
            <Column medium={4}>{""}</Column>
          </Row>
        </form>
      </CustomModal>
    </section>
  );
};

export default Update;
